
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#748190"}},[_c('path',{attrs:{"d":"M13.497 11.424c-.006-.063-.012-.11-.013-.158-.014-.505-.014-.505.46-.542.55-.044 1.041-.55 1.043-1.122.008-2.28.008-4.56 0-6.84-.002-.574-.488-1.077-1.04-1.123-.103-.008-.205-.006-.306-.006-3.848 0-7.694.016-11.54-.011-.93-.007-1.394.677-1.383 1.45.03 2.106.01 4.213.01 6.32 0 .814.463 1.326 1.246 1.33.335.002.28.21.292.417.012.222-.04.324-.289.324C.85 11.46.026 10.63.023 9.455.02 7.27.02 5.087.023 2.904.027 1.74.836.907 1.954.907h11.845c1.098 0 1.895.824 1.895 1.958v6.638c0 1.24-.987 2.114-2.196 1.92z"}}),_c('path',{attrs:{"d":"M12.793 8.463c0 1.211.006 2.424-.002 3.635-.005.765-.722 1.21-1.343.845-.325-.19-.455-.504-.456-.867-.006-2.434-.009-4.867 0-7.3.003-.606.4-.996.942-.98.51.014.858.43.859 1.031v3.636zM7.404 9.56c0 .864.002 1.73 0 2.594-.002.54-.383.945-.88.943-.504-.003-.883-.399-.884-.942-.003-1.74-.003-3.478 0-5.218.001-.542.381-.94.883-.94.5-.002.879.4.88.94.003.874.001 1.748.001 2.623zM8.312 10.194c0-.616-.003-1.232 0-1.847.004-.58.384-1.005.894-1.005.507 0 .892.395.898.97.012 1.27.01 2.54 0 3.81-.005.57-.39.972-.892.973-.517 0-.895-.413-.899-.997-.005-.635-.001-1.27-.001-1.905zM4.73 11.163c0 .326.004.653 0 .98-.007.53-.361.923-.852.95a.844.844 0 01-.906-.813 23.304 23.304 0 01.003-2.3c.025-.485.449-.805.906-.777a.897.897 0 01.847.894c.01.355.002.71.002 1.066z"}})])])
          )
        }
      }
    